import input from '../../../../input';

const light = (params) => input.borderColor.disabled.light(params);

export default light;
